<app-registration-add
  [ofwcaObject]="ofwcaObject"
  [contractObject]="contractObject"
  (registrationCreated)="closeDialog($event)"
  [dialogRef]="dialogRef"
></app-registration-add>
